import { FetchLoginUserResponse } from '../type/interfaces/user';

export const setUserInfoInClient = (userInfo: FetchLoginUserResponse) => {
  if (userInfo) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }
};

export const getIsMobile = (): boolean => {
  if (typeof window !== 'undefined') {
    const ua = navigator.userAgent || '';
    return /iPhone|iPad|iPod|Android/i.test(ua);
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { headers } = require('next/headers');
    const ua = headers().get('user-agent') || '';
    return /iPhone|iPad|iPod|Android/i.test(ua);
  } catch {
    return false;
  }
};
